import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=2bd315ee"
import script from "./ProductVariants.ts?vue&type=script&lang=ts&external"
export * from "./ProductVariants.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports